import React, { useState } from 'react';
import { Row, Col, Card, Statistic, Progress, Modal, List, Badge, Tooltip } from 'antd';

import { QuestionCircleOutlined } from '@ant-design/icons';

const AvanceModal = ({ selectedItem }) => {

    const [isModalVisible, setIsModalVisible] = useState(false);

    if (!selectedItem || !selectedItem.children) return null;

    // 🟢 Función para calcular % de avance solo en nodos finales
    const calculateProgress = (node) => {
        let totalProyectadas = 0;
        let totalEjecutadas = 0;

        const traverse = (children) => {
            children.forEach(child => {
                if (child.isFinal === "yes") {
                    totalProyectadas += parseInt(child.noDeActividades || 0, 10);
                    totalEjecutadas += parseInt(child.noDeEjecutados || 0, 10);
                }
                if (child.children && child.children.length > 0) {
                    traverse(child.children);
                }
            });
        };

        traverse(node.children);

        return totalProyectadas > 0 ? ((totalEjecutadas / totalProyectadas) * 100).toFixed(2) : "0.00";
    };

    // 🟢 Función para calcular % de avance y devolver datos detallados
    const calculateOverallProgress = (node) => {
        let totalProyectadas = 0;
        let totalEjecutadas = 0;

        const traverse = (children) => {
            children.forEach(child => {
                if (child.isFinal === "yes") {
                    totalProyectadas += parseInt(child.noDeActividades || 0, 10);
                    totalEjecutadas += parseInt(child.noDeEjecutados || 0, 10);
                }
                if (child.children && child.children.length > 0) {
                    traverse(child.children);
                }
            });
        };

        traverse(node.children);

        let porcentajeAvance = totalProyectadas > 0 ? ((totalEjecutadas / totalProyectadas) * 100).toFixed(2) : "0.00";

        return {
            totalProyectadas,
            totalEjecutadas,
            porcentajeAvance
        };
    };

    // 🟢 Obtener datos del avance general
    const { totalProyectadas, totalEjecutadas, porcentajeAvance } = calculateOverallProgress(selectedItem);


    // 🟢 Filtrar solo los nodos de PRIMER NIVEL (evita 1.1, 2.1, etc.)
    const actividadesConAvance = selectedItem.children
        .filter(child =>
            !child.title.match(/^\d+\.\d+/) // 🔍 Evita títulos como "1.1", "2.1", etc.
        )
        .map(child => ({
            title: child.title,
            key: child.key,
            avance: calculateProgress(child) // Calcula el % de avance
        }));

    return (
        <>
            <Tooltip title="Ver % de avance">
                <QuestionCircleOutlined
                    onClick={() => setIsModalVisible(true)}
                    style={{ fontSize: 18, cursor: 'pointer', marginLeft: 10 }}
                />
            </Tooltip>

            <Modal
                title="Avance de las acciones de fortalecimiento"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width="70%"
            >
                <h4 style={{ textAlign: 'center', fontWeight: 'bold', color: '#042956' }}>
                    {selectedItem.title}
                </h4>
                <div>
                    {/* 🟢 Mostramos las actividades proyectadas y ejecutadas en una fila bien distribuida */}
                    <Row gutter={[16, 16]} justify="center">
                        <Col xs={12} sm={8} md={6}>
                            <Card bordered style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                <Statistic
                                    title="Actividades Proyectadas"
                                    value={totalProyectadas}
                                    valueStyle={{ fontSize: '20px', color: '#042956' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={12} sm={8} md={6}>
                            <Card bordered style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                <Statistic
                                    title="Actividades Ejecutadas"
                                    value={totalEjecutadas}
                                    valueStyle={{ fontSize: '20px', color: '#3f8600' }}
                                />
                            </Card>
                        </Col>
                    </Row>

                    {/* 🟢 Sección del porcentaje de avance */}
                    <Row justify="center" style={{ marginTop: 20 }}>
                        <Col xs={24} sm={16} md={12}>
                            <Card bordered>
                                <h5 style={{ textAlign: 'center', color: '#042956', marginBottom: 10, fontSize: '16px' }}>
                                    % Avance General
                                </h5>

                                <Progress
                                    percent={parseFloat(porcentajeAvance)}
                                    status={porcentajeAvance >= 100 ? "success" : "active"}
                                    strokeColor={porcentajeAvance >= 70 ? '#52c41a' : porcentajeAvance >= 50 ? '#faad14' : '#f5222d'}
                                    showInfo
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
                <List
                    itemLayout="horizontal"
                    dataSource={actividadesConAvance}
                    renderItem={(item, index) => (
                        <List.Item>
                            <List.Item.Meta
                                title={
                                    <span>
                                        {item.title}
                                    </span>
                                }
                            />
                            <Badge
                                count={`${item.avance}%`}
                                style={{
                                    backgroundColor: item.avance >= 75 ? '#52c41a' : item.avance >= 50 ? '#faad14' : '#f5222d',
                                    fontSize: 14,
                                    padding: '0px 10px'
                                }}
                            />
                        </List.Item>
                    )}
                />
            </Modal>
        </>
    );
};

export default AvanceModal;
